export default {
  // 已有文本
  'pages.dashboard.text': '無縫接入門店管理生態，提供遠程積分管理解決方案。',
  'pages.dashboard.storeTitle': '門店',
  'pages.dashboard.management.title': '總部管理',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': '顯示會員註冊二維碼',
  'pages.dashboard.qrcode.title': '會員註冊二維碼',
  'pages.dashboard.qrcode.download': '下載二維碼',
  'pages.dashboard.qrcode.close': '關閉',

  // 其他已有文本
  'pages.dashboard.tooltip.members': '會員管理',
  'pages.dashboard.tooltip.cards': '禮品卡',
  'pages.dashboard.tooltip.coupons': '優惠券',
  'pages.dashboard.tooltip.orders': '訂單',

  'pages.dashboard.userApp.management.title': '用戶 App 管理',
  'pages.dashboard.userApp.posters.button': '宣傳海報',
  'pages.dashboard.userApp.posters.title': '宣傳海報管理',
  'pages.dashboard.userApp.posters.add': '新增海報',
  'pages.dashboard.userApp.posters.edit': '編輯海報',
  'pages.dashboard.userApp.posters.noPermission.title': '無權限',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    '你無權訪問該總部的用戶 App 宣傳海報管理。',
  'pages.dashboard.userApp.posters.upload.imageTypeError': '只能上傳 jpg、png 或 webp 圖片',
  'pages.dashboard.userApp.posters.upload.sizeError': '圖片不能超過 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': '請上傳海報圖片',
  'pages.dashboard.userApp.posters.message.saveSuccess': '保存成功',
  'pages.dashboard.userApp.posters.message.deleteSuccess': '刪除成功',
  'pages.dashboard.userApp.posters.empty.all': '暫無海報',
  'pages.dashboard.userApp.posters.empty.carousel': '暫無頂部滾動海報',
  'pages.dashboard.userApp.posters.empty.static': '暫無靜態海報',
  'pages.dashboard.userApp.posters.delete.confirm': '確認刪除這張海報？',
  'pages.dashboard.userApp.posters.delete.ok': '刪除',
  'pages.dashboard.userApp.posters.delete.cancel': '取消',
  'pages.dashboard.userApp.posters.type.carousel': '滾動翻頁海報',
  'pages.dashboard.userApp.posters.type.static': '靜態海報',
  'pages.dashboard.userApp.posters.sort': '排序',
  'pages.dashboard.userApp.posters.section.carousel': '頂部滾動海報',
  'pages.dashboard.userApp.posters.section.static': '靜態海報',
  'pages.dashboard.userApp.posters.form.title': '海報標題',
  'pages.dashboard.userApp.posters.form.title.required': '請輸入海報標題',
  'pages.dashboard.userApp.posters.form.title.placeholder': '例如：週末狂歡購',
  'pages.dashboard.userApp.posters.form.displayType': '海報類型',
  'pages.dashboard.userApp.posters.form.displayType.required': '請選擇海報類型',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    '滾動翻頁海報（頂部自動輪播，建議 1536 x 860）',
  'pages.dashboard.userApp.posters.form.displayType.static':
    '靜態海報（下方列表，建議 1536 x 560）',
  'pages.dashboard.userApp.posters.form.sortOrder': '滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.required': '請選擇滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.page': '第 {value} 頁',
  'pages.dashboard.userApp.posters.form.image': '海報圖片',
  'pages.dashboard.userApp.posters.form.image.replace': '替換圖片（可選）',
  'pages.dashboard.userApp.posters.form.image.select': '選擇圖片',
  'pages.dashboard.userApp.posters.scope.common': '通用海報',
  'pages.dashboard.userApp.posters.scope.store': '門店海報',
  'pages.dashboard.userApp.posters.store.placeholder': '請選擇門店',
  'pages.dashboard.userApp.posters.store.viewOnly': '僅可查看——需要門店海報管理權限',
};
